import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-screw-air-compressor',
  templateUrl: './screw-air-compressor.component.html',
  styleUrls: ['./screw-air-compressor.component.scss']
})
export class ScrewAirCompressorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
